<!--设置薪资标准弹窗-->
<template>
  <div>
    <el-dialog
      :visible.sync="visiable"
      width="600px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleBeforeClose"
      title="设置工资标准"
    >
      <el-form :model="form" label-position="right" label-width="120px">
        <el-form-item label="上班标准：" style="margin-bottom:0">
          <el-input style="width: 65px;height:30px;margin-right:10px" v-model="form.workStandard" @focus="workTimeSelectShow=true"></el-input>
          小时算1个工
        </el-form-item>
        <el-form-item label="每个工多少钱：" style="margin-bottom:0">
          <el-input style="width: 65px;height: 30px;margin-right:10px" maxlength="6" v-model="form.workStandardSalary"  
          @input="Mixin_commonLimitInput('form.workStandardSalary',6,2,true)"></el-input>
          {{ form.workStandardSalary }}元/个工
        </el-form-item>
        <el-form-item label=" 加班标准：" style="margin-bottom:0">
          <el-radio-group v-model="form.workOvertimeType">
            <el-radio label="1">按工天算</el-radio>
            <el-radio label="2">按小时算</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="form.workOvertimeType==='1'">
          <el-row class="workover_content" style="margin-top:9px">
            <el-col>
              <span style="color:#666">加班标准：</span>
              <el-input style="width: 65px;height30px;margin-right:10px" v-model="form.workOvertimeStandard"
                        @focus="overTimeSelectShow=true"></el-input>
             <span style="color:#333333"> 加班{{ form.workOvertimeStandard }}小时算一个工</span>
            </el-col>
            <el-col>
              <span style="color:#666">加班每小时多少钱：</span><span style="color:#333333">{{ salaryForDay || '--' }}元/小时</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-show="form.workOvertimeType==='2'">
          <el-row class="workover_content" style="margin-top: 9px;padding-bottom: 5px;">
            <el-col>
              加班每小时多少钱：
              <el-input style="width: 65px;height: 30px;margin-right:10px" v-model="salaryForTime"
                        @input="Mixin_commonLimitInput('salaryForTime',6,2,true)"></el-input>
              {{ salaryForTime }}元/小时
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <div slot="footer" class="flex_jc_center footer">
        <el-button @click="reset">重 置</el-button>
        <el-button @click="save" type="primary" style="margin-left:20px">确 定</el-button>
      </div>
    </el-dialog>

    <!--    设置多少小时算一个工的弹窗-->
    <WorkTimeSelect :visiable.sync="workTimeSelectShow" :value.sync="form.workStandard"></WorkTimeSelect>
    <!--    设置加班标准的弹窗-->
    <WorkTimeSelect :visiable.sync="overTimeSelectShow" :value.sync="form.workOvertimeStandard"></WorkTimeSelect>
  </div>
</template>

<script>
import {wokerForm} from '@/mixins/validate/work.js'
import {api} from '@/api/apiRecord.js'

export default {
  name: "setSalaryStandard",
  mixins: [wokerForm],
  components: {
    WorkTimeSelect: () => import("./workTimeSelect"), // 选择工作时长弹窗
  },
  props: {
    visiable: {
      type: Boolean
    },
    detail: {
      type: Object
    }
  },
  data() {
    return {
      wranPic: require("@/assets/record/wran.png"),
      workTimeSelectShow: false,
      overTimeSelectShow: false,
      form: {},
      salaryForDay:"",
      salaryForTime:"",
    }
  },
  mounted() {
    this.countOverPrice()
    this.form = Object.assign({}, this.detail)
  },
  watch: {
    'form.workStandardSalary'() { // 每个工多少钱
      this.countOverPrice()
    },
    'form.workOvertimeStandard'() { // 加班几小时算一个工
      this.countOverPrice()
    },
    salaryForDay(val){ // 加班工资按天计算
      if(this.form.workOvertimeType=="1"){
        this.form.workOvertimeSalary=val
      }
    },
    salaryForTime(val){ // 加班工资按小时计算
      if(this.form.workOvertimeType=="2"){
        this.form.workOvertimeSalary=val
      }
    },
    visiable(val) {
      if (val) {
        this.form = {...this.detail}
        if(this.form.workOvertimeType=="1"){
          this.salaryForDay=this.form.workOvertimeSalary
        }else{
          this.salaryForTime=this.form.workOvertimeSalary
        }
      }
    }
  },
  methods: {
    handleBeforeClose() {
      this.$emit('update:visiable', false)
    },
    // 计算加班每小时多少钱
    countOverPrice() {
      if (this.form.workStandardSalary && this.form.workOvertimeStandard) {
        this.salaryForDay = (this.form.workStandardSalary / this.form.workOvertimeStandard).toFixed(2)
      } else {
        this.salaryForDay = ""
      }
    },
    // 重置工资标准
    reset() {
      this.form.workOvertimeSalary=""
      this.form.workOvertimeStandard=""
      this.form.workOvertimeType="1"
      this.form.workStandard=""
      this.form.workStandardSalary=""
      this.salaryForDay=""
      this.salaryForTime=""
    },
    // 确定设置工资标准
    async save() {
      if (this.form.workStandardSalary && this.form.workOvertimeSalary && this.form.workStandard) {
        if(this.form.workOvertimeType=="1"){
          this.form.workOvertimeSalary = this.salaryForDay
        }else{
          this.form.workOvertimeSalary = Number(this.salaryForTime).toFixed(2)
        }
        this.form.workStandardSalary=Number(this.form.workStandardSalary).toFixed(2)
        this.$emit('update:detail', this.form)
        this.handleBeforeClose()
      } else { // 工资标准未设置完全
        this.$message.tips('当前工资标准未设置完全，是否暂不设置工资标准？',(v)=>{
          if(v){
            this.reset()
            this.$emit('update:detail', this.form)
            this.handleBeforeClose()
          }
        })
      }
    }
    ,
    // 温馨提示弹窗的确定
    handleQuit() {
      this.handleBeforeClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.workover_content {
  padding: 5px 10px 0;
  background: #F5F7FA;
}

.bg_gold {
  background: #B79255;
}

.color_fff {
  color: #fff;
}

.wran_pic {
  margin-bottom: 19px;
  width: 60px;
  height: 54px;
}

.content {
  text-align: center;
}

/deep/ .el-dialog__footer {
  padding-top: 0;
  padding-bottom: 40px;
}
/deep/.el-dialog__body{
  padding-top: 15px;
  padding-bottom: 18px;
}
/deep/.el-input__inner{
  width: 65px;
  height: 30px;
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}
</style>
